// extracted by mini-css-extract-plugin
export default {"LabeledContainer":"XhwDe","Label--default":"xD0XV","Label":"FF1N5","LabeledContainer--horizontal":"k1QAP","Label--big":"vQlU2","Label--small":"qxyHy","Label--compact":"zuri2"};